module.exports = __webpack_public_path__ + "static/1984-3-11d25c5934ca9f0f974948673cd4e285.png";